import { render, staticRenderFns } from "./CbsDataReference.vue?vue&type=template&id=7eb33408&scoped=true"
import script from "./CbsDataReference.vue?vue&type=script&lang=js"
export * from "./CbsDataReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb33408",
  null
  
)

export default component.exports